import { AutoFixHigh } from "@mui/icons-material";
import { Stack, Button } from "@mui/material";

import BottomActionBar from "@pages/Layout/BottomActionBar";
import { useNavigate } from "react-router-dom";

interface Props {
  orderId: number;
  showCancelButton: boolean;
  onSubmitPlanGeneration: () => void;
  disablePlanGeneration: boolean;
}

const PlanningTemplateBottomBar = ({
  orderId,
  showCancelButton,
  onSubmitPlanGeneration,
  disablePlanGeneration,
}: Props) => {
  const navigate = useNavigate();

  return (
    <BottomActionBar>
      <Stack
        direction="row-reverse"
        sx={{
          justifyContent: "space-between",
          width: 1,
          borderTop: "1px solid",
          borderTopColor: "divider",
          padding: 2,
        }}
      >
        <Button
          disabled={disablePlanGeneration}
          startIcon={<AutoFixHigh />}
          sx={{ width: "max-content" }}
          variant="contained"
          color="primary"
          onClick={onSubmitPlanGeneration}
        >
          Generate Plan
        </Button>

        {showCancelButton && (
          <Button
            data-testid={"planning-template-cancel"}
            variant="outlined"
            onClick={() => navigate(`/commandcenter/${orderId}/automated`)}
          >
            Cancel
          </Button>
        )}
      </Stack>
    </BottomActionBar>
  );
};

export default PlanningTemplateBottomBar;
